<template>
    <v-layout>
        <v-flex>
            <v-btn v-if="!autorizado" outlined color="orange" @click="editModeOn = true" >Autorizar por excepción <v-icon right dark>thumb_up</v-icon><v-icon right dark>thumb_down</v-icon></v-btn>         
            <v-btn v-if="autorizado" outlined color="green" @click="editModeOn = true" >AUTORIZADO por {{ usuarioAutoriza.login}} <v-icon right dark>thumb_up</v-icon></v-btn>         
        </v-flex>

        <v-dialog v-model="editModeOn" width="400" persistent>
            <v-card>
                <v-card-title>
                    <h3>Autorización por Excepción</h3>
                </v-card-title>
                <v-card-text>
                    <v-flex xs8>
                        <v-text-field label="Ingrese su CAR (Código de Autorización Rápida)" type="password" v-model="car" >
                            <template v-slot:append-outer v-if="!carValidado">
                                <v-tooltip bottom   >
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" @click="checkCAR">check_circle_outline</v-icon>
                                    </template>
                                    Validar CAR
                                </v-tooltip>                                                     
                            </template>
                            <template v-slot:append-outer v-else>
                                <v-tooltip bottom   >
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" color="green">thumb_up</v-icon>
                                    </template>
                                    CAR Validado
                                </v-tooltip>                                                     
                            </template>
                        </v-text-field>
                    </v-flex>
                    <v-text-field label="Usuario que Autoriza" v-model="usuarioAutoriza.nombre" :disabled="true"></v-text-field>
                    <v-text-field label="Explique por qué se Autoriza" v-model="motivo" ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="editModeOn = false; autorizado=false; carValidado = false; car=''">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined @click="Autorizar" color="green" :disabled="!carValidado">Autorizar<v-icon right color="green">thumb_up</v-icon> </v-btn>                    
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>

import Vue from 'vue'
import { http } from '@/axios'

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data: () => ({
        editModeOn: false,
        loading: false,
        autorizado: false,
        car: '',
        carValidado: false,
        motivo: '',
        usuarioAutoriza: {}
    }),
    props:{
        EstaAutorizado: {
            type: Boolean,
            default: false
        },
        UsuarioAutoriza: {
            type: String,            
        },
        MotivoAutoriza: {
            type: String,            
        },
    },
    methods:{
        ...mapMutations(["alertClear", "alertSuccess", "alertWarning", "alertError"]),
        async checkCAR(){
            if( this.car.length !=6 ){
                this.alertError('Debe ingresar el código de autorización rápida (CAR), que tiene 6 caracteres.')
                return
            }

            this.loading = true
            try {
                var result = await http.get('usuarios/car/' + this.car);
                
                var model = result.entity;
                console.log(result)

                if(!model || !model.puedeAutorizar){
                    this.alertError('CAR Inválido')
                }
                else{
                    this.usuarioAutoriza = model
                    this.carValidado = true
                }
                
            } catch (error) {
                // Error
                this.alertError(error)
            }
            this.loading = false
        },
        Autorizar(){
            this.autorizado = true
            this.editModeOn = false
            this.car = ''

            this.$emit('update:EstaAutorizado', this.autorizado)
            this.$emit('update:UsuarioAutoriza', this.usuarioAutoriza.login)
            this.$emit('update:MotivoAutoriza', this.motivo)
        }
    }
}
</script>
